import { Icon } from "semantic-ui-react";
import { GAME_LIST } from "../helpers/gameList";
import ShowGameDetail from "./ShowGameDetail";
import { useEffect, useMemo, useRef, useState } from "react";
import { appName } from "../config";
import SwiperGameList from "./SwiperGameList/SwiperGameList";
import LoaderComponent from "./Loading/LoaderComponent";
import LoadingIcon from "./Loading/LoadingIcon";
import { RiArrowDownSLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router";
import React from "react";
import useDeviceType from "../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useCasinoType from "../hook/useCasinoType";
import ObserveComponents from "../utils/observeComponents";
import LoadingLine from "./Loading/LoadingLine";
import LoadingImage from "./Loading/LoadingImage";
import { useSelector } from "react-redux";
import ObserveInView from "../utils/observeInView";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const OBSERVE_TIME = 1000;

const GameCatalog = ({
  mainTitle,
  gameType,
  itemClass, //遊戲item class
  swiperProps,
  swiperClassName,
  closeComponent, //關閉組件
  wrapperClassName, //外層class
  hiddenHeader, //隱藏header
  directToPlatform, //直接導向平台
  dontTranslateMainTitle, //不翻譯mainTitle
  listType = "game", //game,promotion,sponsor
  list = [], // 列表
  observeFalse,
  hiddenButtonNavigator, //隱藏All ... 按鈕
  forceShow, //強制顯示維護的遊戲
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const splideRef = useRef();

  const casinoType = useCasinoType();

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { game_subtype } = isHandleAllGame;

  const location = useLocation();

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const findCasinoType = useMemo(() => {
    if (isGameBox) return "casino";
    const subTypeConfig = game_subtype?.find(
      (item) => item.game_subtype === mainTitle
    );
    const belongType =
      mainTitle === "MyFavorite" ||
      mainTitle === "News" ||
      mainTitle === "Top" ||
      mainTitle === "ClickedGames"
        ? casinoType
        : subTypeConfig?.belong_type === "Slots"
        ? "casino"
        : subTypeConfig?.belong_type?.toLowerCase() || "casino";

    return belongType;
  }, [mainTitle]);

  const navigate = useNavigate();

  const isMobile = useDeviceType() === "Mobile";

  const handleSlideRight = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex + 3;

      splide.go(newIndex);
    }
  };
  const handleSlideLeft = () => {
    if (splideRef.current) {
      const splide = splideRef.current.splide;
      const currentIndex = splide.index;
      const newIndex = currentIndex - 3;

      splide.go(newIndex);
    }
  };

  const listSize = useMemo(() => {
    return isMobile ? list?.slice(0, 15) : list?.slice(0, 30);
  }, [isMobile, list]);

  return (
    <ObserveInView
      props={{
        itemClass: itemClass,
        swiperProps: swiperProps,
        swiperClassName: swiperClassName,
      }}
      observeFalse={observeFalse}
    >
      <section
        className={`${closeComponent} relative rounded-[30px] px-[10px] py-[5px] my-[5px] ${wrapperClassName}`}
      >
        <>
          <section className="relative z-10">
            {hiddenHeader || (
              <section className="flex justify-between h-[35px] mb-[10px]">
                <div className="flex items-center">
                  <LoadingImage
                    closeInverted
                    className={`w-[130px] h-[20px] rounded-full`}
                  >
                    <p
                      className={`text-base-light-dark dark:text-base-light-white sm:text-2xl text-xl font-medium mb-[0px]`}
                    >
                      {mainTitle && !dontTranslateMainTitle
                        ? i18n(mainTitle)
                        : mainTitle}
                    </p>
                    <p className="text-main-color sm:text-2xl text-xl font-bold italic mb-[0px]">
                      {gameType}
                    </p>
                  </LoadingImage>
                </div>
                <div className="flex items-center gap-[5px]">
                  {listType === "game" && (
                    <>
                      {mainTitle && !hiddenButtonNavigator ? (
                        <Link
                          to={
                            directToPlatform
                              ? `/${findCasinoType}/category/${directToPlatform}/all`
                              : `${
                                  findCasinoType ? `/${findCasinoType}/` : ""
                                }category/all/${mainTitle}`
                          }
                          className="bg-base-deep-gray dark:bg-base-light-dark dark:text-base-white text-base-light-dark cursor-pointer py-[8px] px-[10px] h-[40px] font-medium text-sm flex items-center rounded-[5px]"
                        >
                          <LoadingLine className={`!w-[60px] !h-[10px] !mt-0`}>
                            {i18n("all")}{" "}
                            {mainTitle && !dontTranslateMainTitle
                              ? i18n(mainTitle)
                              : mainTitle}
                          </LoadingLine>
                        </Link>
                      ) : null}
                      <div
                        onClick={handleSlideLeft}
                        className="w-[40px] h-[40px] md:flex hidden items-center justify-center rounded-lg bg-base-deep-gray dark:bg-base-light-dark cursor-pointer"
                      >
                        <MdOutlineKeyboardArrowLeft className="dark:text-base-white text-base-light-dark text-lg" />
                      </div>
                      <div
                        onClick={handleSlideRight}
                        className="w-[40px] h-[40px] md:flex hidden items-center justify-center rounded-lg bg-base-deep-gray dark:bg-base-light-dark  cursor-pointer"
                      >
                        <MdOutlineKeyboardArrowRight className="dark:text-base-white text-base-light-dark text-lg" />
                      </div>
                    </>
                  )}
                </div>
              </section>
            )}
            <SwiperGameList
              isHot={mainTitle === "Top"}
              forceShow={forceShow}
              ref={splideRef}
              list={listSize}
              listType={listType}
              itemClass={itemClass}
              swiperProps={swiperProps}
              swiperClassName={swiperClassName}
            />
          </section>
        </>
      </section>
    </ObserveInView>
  );
};

export default React.memo(GameCatalog);
